const tdk = require("@/assets/js/TDK.js").tdk;
import Utils from "@/common/util.js";
//viewport
const updateViewport = function (to) {
  let vp = document.querySelectorAll("head meta[name='viewport']")[0];
  //记录模版初始值，有则记录content, 无则记录为空字符串

  if (window.metaVpcontent === undefined) {
    window.metaVpcontent = vp ? vp.content : "";
  }

  //获取content内容
  let content = null;

  if (!to || !to.meta || !to.meta.viewport) {
    content = window.metaVpcontent;
  } else if (typeof to === "string") {
    content = to;
  } else {
    content = to.meta.viewport;
  }

  //设置
  if (vp) {
    vp.content = content;
  } else {
    let meta = document.createElement("meta");

    meta.name = "viewport";
    meta.content = content;
    document.getElementsByTagName("head")[0].appendChild(meta);
  }
};

//title切换
const setTitle = function (to = {}) {
  if (!to.meta.title) {
    to.meta.title = tdk.title;
  }
  if (!to.meta.description) {
    to.meta.description = tdk.description;
  }
  if (!to.meta.keywords) {
    to.meta.keywords = tdk.keywords;
  }

  if (to.meta.title && to.meta.title instanceof Object) {
    document.title = to.meta.title[window._i18n.locale];
  } else if (to.meta.title) {
    document.title = to.meta.title;
  }
};

//keywords、description切换
const setKeywordsDescription = function (to) {
  Array.from(document.head.children).forEach((v) => {
    //console.log(v.name);
    if (v.name == "keywords") {
      //keyword切换
      if (to.meta.keywords && to.meta.keywords instanceof Object) {
        v.content = to.meta.keywords[window._i18n.locale];
      } else if (to.meta.keywords) {
        v.content = to.meta.keywords;
      }
    } else if (v.name == "description") {
      //description切换
      if (to.meta.description && to.meta.description instanceof Object) {
        v.content = to.meta.description[window._i18n.locale];
      } else if (to.meta.description) {
        v.content = to.meta.description;
      }
    }
  });
};

//加载国际化文件
async function asyncLoadMessage(lang, fn) {
  //同步版本

  let message = fn();

  let msg = {};

  Object.keys(message).map((v) => {
    msg[v] = message[v];
  });
  window._i18n.setLocaleMessage(lang, {
    ...window._i18n.messages[lang],
    ...msg,
  });

  //异步版本
  /*
    return await fn().then(message => {
        let msg = {};
        Object.keys(message).map(v => {
            msg[v] = message[v];
        });
        window._i18n.setLocaleMessage(lang, {
            ...window._i18n.messages[lang],
            ...msg
        });
    });
    */
}


//监听跳转
const toH5 = function (to, next) {
  const h5Path = ['/h5', '/download']
  const whiteList = ['/futures/register', '/registers', '/v3/otc/credit-card', '/futures/world-cup']
  const isH5path = h5Path.some(item => to.fullPath.includes(item))
  const isWhite = whiteList.some(item => to.fullPath.includes(item))
  if (isWhite) {
    next()
    return
  }
  if (!isH5path) {
    if (Utils.isMobile()) {
      next({path: '/h5/index', query: to.query})
    }
  } else {
    if (!Utils.isMobile()) {
      next({path: '/', query: to.query})
      // next('/')
    }
  }
};


const beforeEach = (to, from, next) => {
  if (to.path.includes('living') && (window._i18n.locale != 'zh_CN' && window._i18n.locale != 'zh_TW')) {
    next({ path: '/' })
  } else {
    next()
  }
  if (to.path == '/futures/register' || to.path.includes('/registers') ) {
    if (to.query.agentid) {
      sessionStorage.setItem('agentid', to.query.agentid)
    } else {
      sessionStorage.removeItem('agentid')
    }
  } else {
    const agentid = sessionStorage.getItem('agentid')
    if (agentid) {
      to.query.agentid = agentid
    }
  }
  /* 路由发生变化修改页面title */

  setTitle(to);

  setKeywordsDescription(to);

  updateViewport(to);

  toH5(to, next)
  //加载国际化文件
  if (to.meta.i18n && typeof to.meta.i18n[window._i18n.locale] == "function") {
    asyncLoadMessage(
      window._i18n.locale,
      to.meta.i18n[window._i18n.locale]
    ).then(next);
  } else {
    next()
  }
};

const afterEach = (to, from) => {
  console.log(to, from);
  clearTimeout(window.afterEachLoadMessage);
  window.afterEachLoadMessage = null;
  window.afterEachLoadMessage = setTimeout(() => {
    if (to.meta.i18n && to.meta.i18n instanceof Object) {
      Object.keys(to.meta.i18n).forEach((v) => {
        typeof to.meta.i18n[v] === "function" &&
          asyncLoadMessage(v, to.meta.i18n[v]);
      });
    }
  }, 1000);
};

export {
  beforeEach,
  setKeywordsDescription,
  setTitle,
  updateViewport,
  afterEach,
  asyncLoadMessage,
};



// WEBPACK FOOTER //
// ./src/assets/js/router.extends.js